import { useContext } from 'react'

import { RelatedProductsContext, type IRelatedProductsContext } from './RelatedProductsContext'

export const useRelatedProducts = (): IRelatedProductsContext => {
  return useContext(RelatedProductsContext)
}

export default useRelatedProducts
